import React from 'react';
import './content.scss';

// under .health-guide
const Content: React.FC<any> = ({ children, id, image = 'hip-header-bg_729097ec.png', imageAlt = "", imageStyle = {}, reducer, next }) => {
    const [state, dispatch] = reducer;

    return (
        <section className="self-test__content" id={id}>
            <div className="self-test__content-container">
                <div className="self-test__content-container-columns container">
                    <div className="self-test__content-container-column-text-container">
                        { children }
                        {
                            next &&
                            <button className="self-test__button primary" onClick={() => dispatch({ type: 'change', data: { anchorId: next } })}>
                                下一頁
                            </button>
                        }
                    </div>
                    <div className="self-test__content-container-column-image-container">
                        <figure className="self-test__content-container-column-image-container-image">
                            <img
                                style={imageStyle}
                                alt=""
                                data-src={image}
                                src={image}
                            />
                            <noscript><img src={image} alt="" /></noscript>
                        </figure>
                        <p></p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Content;